/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addLoyaltyUserPoint } from '../fn/loyalty/add-loyalty-user-point';
import { AddLoyaltyUserPoint$Params } from '../fn/loyalty/add-loyalty-user-point';
import { addLoyaltyUserReward } from '../fn/loyalty/add-loyalty-user-reward';
import { AddLoyaltyUserReward$Params } from '../fn/loyalty/add-loyalty-user-reward';
import { Bonus } from '../models/bonus';
import { Bonuses } from '../models/bonuses';
import { createLoyaltyProgram } from '../fn/loyalty/create-loyalty-program';
import { CreateLoyaltyProgram$Params } from '../fn/loyalty/create-loyalty-program';
import { createLoyaltyProgramBonus } from '../fn/loyalty/create-loyalty-program-bonus';
import { CreateLoyaltyProgramBonus$Params } from '../fn/loyalty/create-loyalty-program-bonus';
import { createLoyaltyProgramReward } from '../fn/loyalty/create-loyalty-program-reward';
import { CreateLoyaltyProgramReward$Params } from '../fn/loyalty/create-loyalty-program-reward';
import { createLoyaltyProgramTier } from '../fn/loyalty/create-loyalty-program-tier';
import { CreateLoyaltyProgramTier$Params } from '../fn/loyalty/create-loyalty-program-tier';
import { getLoyaltyProgram } from '../fn/loyalty/get-loyalty-program';
import { GetLoyaltyProgram$Params } from '../fn/loyalty/get-loyalty-program';
import { getLoyaltyProgramBonus } from '../fn/loyalty/get-loyalty-program-bonus';
import { GetLoyaltyProgramBonus$Params } from '../fn/loyalty/get-loyalty-program-bonus';
import { getLoyaltyProgramBonuses } from '../fn/loyalty/get-loyalty-program-bonuses';
import { GetLoyaltyProgramBonuses$Params } from '../fn/loyalty/get-loyalty-program-bonuses';
import { getLoyaltyProgramReward } from '../fn/loyalty/get-loyalty-program-reward';
import { GetLoyaltyProgramReward$Params } from '../fn/loyalty/get-loyalty-program-reward';
import { getLoyaltyProgramRewards } from '../fn/loyalty/get-loyalty-program-rewards';
import { GetLoyaltyProgramRewards$Params } from '../fn/loyalty/get-loyalty-program-rewards';
import { getLoyaltyPrograms } from '../fn/loyalty/get-loyalty-programs';
import { GetLoyaltyPrograms$Params } from '../fn/loyalty/get-loyalty-programs';
import { getLoyaltyProgramTier } from '../fn/loyalty/get-loyalty-program-tier';
import { GetLoyaltyProgramTier$Params } from '../fn/loyalty/get-loyalty-program-tier';
import { getLoyaltyProgramTiers } from '../fn/loyalty/get-loyalty-program-tiers';
import { GetLoyaltyProgramTiers$Params } from '../fn/loyalty/get-loyalty-program-tiers';
import { getLoyaltyUser } from '../fn/loyalty/get-loyalty-user';
import { GetLoyaltyUser$Params } from '../fn/loyalty/get-loyalty-user';
import { getLoyaltyUserPoint } from '../fn/loyalty/get-loyalty-user-point';
import { GetLoyaltyUserPoint$Params } from '../fn/loyalty/get-loyalty-user-point';
import { getLoyaltyUserPoints } from '../fn/loyalty/get-loyalty-user-points';
import { GetLoyaltyUserPoints$Params } from '../fn/loyalty/get-loyalty-user-points';
import { getLoyaltyUserReward } from '../fn/loyalty/get-loyalty-user-reward';
import { GetLoyaltyUserReward$Params } from '../fn/loyalty/get-loyalty-user-reward';
import { getLoyaltyUserRewards } from '../fn/loyalty/get-loyalty-user-rewards';
import { GetLoyaltyUserRewards$Params } from '../fn/loyalty/get-loyalty-user-rewards';
import { LoyaltyUser } from '../models/loyalty-user';
import { postProgramOptin } from '../fn/loyalty/post-program-optin';
import { PostProgramOptin$Params } from '../fn/loyalty/post-program-optin';
import { Program } from '../models/program';
import { ProgramOptin } from '../models/program-optin';
import { Programs } from '../models/programs';
import { Reward } from '../models/reward';
import { Rewards } from '../models/rewards';
import { Tier } from '../models/tier';
import { Tiers } from '../models/tiers';
import { updateLoyaltyProgram } from '../fn/loyalty/update-loyalty-program';
import { UpdateLoyaltyProgram$Params } from '../fn/loyalty/update-loyalty-program';
import { updateLoyaltyProgramBonus } from '../fn/loyalty/update-loyalty-program-bonus';
import { UpdateLoyaltyProgramBonus$Params } from '../fn/loyalty/update-loyalty-program-bonus';
import { updateLoyaltyProgramReward } from '../fn/loyalty/update-loyalty-program-reward';
import { UpdateLoyaltyProgramReward$Params } from '../fn/loyalty/update-loyalty-program-reward';
import { updateLoyaltyProgramTier } from '../fn/loyalty/update-loyalty-program-tier';
import { UpdateLoyaltyProgramTier$Params } from '../fn/loyalty/update-loyalty-program-tier';
import { updateLoyaltyUserPoint } from '../fn/loyalty/update-loyalty-user-point';
import { UpdateLoyaltyUserPoint$Params } from '../fn/loyalty/update-loyalty-user-point';
import { updateLoyaltyUserReward } from '../fn/loyalty/update-loyalty-user-reward';
import { UpdateLoyaltyUserReward$Params } from '../fn/loyalty/update-loyalty-user-reward';
import { UserPoint } from '../models/user-point';
import { UserPoints } from '../models/user-points';
import { UserReward } from '../models/user-reward';
import { UserRewards } from '../models/user-rewards';

@Injectable({ providedIn: 'root' })
export class LoyaltyService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getLoyaltyPrograms()` */
  static readonly GetLoyaltyProgramsPath = '/loyalty/programs';

  /**
   * Fetch loyalty programs.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLoyaltyPrograms()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLoyaltyPrograms$Response(params: GetLoyaltyPrograms$Params, context?: HttpContext): Observable<StrictHttpResponse<Programs>> {
    return getLoyaltyPrograms(this.http, this.rootUrl, params, context);
  }

  /**
   * Fetch loyalty programs.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLoyaltyPrograms$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLoyaltyPrograms(params: GetLoyaltyPrograms$Params, context?: HttpContext): Observable<Programs> {
    return this.getLoyaltyPrograms$Response(params, context).pipe(
      map((r: StrictHttpResponse<Programs>): Programs => r.body)
    );
  }

  /** Path part for operation `createLoyaltyProgram()` */
  static readonly CreateLoyaltyProgramPath = '/loyalty/programs';

  /**
   * Create a loyalty program.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createLoyaltyProgram()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createLoyaltyProgram$Response(params: CreateLoyaltyProgram$Params, context?: HttpContext): Observable<StrictHttpResponse<Program>> {
    return createLoyaltyProgram(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a loyalty program.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createLoyaltyProgram$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createLoyaltyProgram(params: CreateLoyaltyProgram$Params, context?: HttpContext): Observable<Program> {
    return this.createLoyaltyProgram$Response(params, context).pipe(
      map((r: StrictHttpResponse<Program>): Program => r.body)
    );
  }

  /** Path part for operation `getLoyaltyProgram()` */
  static readonly GetLoyaltyProgramPath = '/loyalty/programs/{programId}';

  /**
   * Fetch loyalty program by id.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLoyaltyProgram()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLoyaltyProgram$Response(params: GetLoyaltyProgram$Params, context?: HttpContext): Observable<StrictHttpResponse<Program>> {
    return getLoyaltyProgram(this.http, this.rootUrl, params, context);
  }

  /**
   * Fetch loyalty program by id.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLoyaltyProgram$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLoyaltyProgram(params: GetLoyaltyProgram$Params, context?: HttpContext): Observable<Program> {
    return this.getLoyaltyProgram$Response(params, context).pipe(
      map((r: StrictHttpResponse<Program>): Program => r.body)
    );
  }

  /** Path part for operation `updateLoyaltyProgram()` */
  static readonly UpdateLoyaltyProgramPath = '/loyalty/programs/{programId}';

  /**
   * Update a loyalty program.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateLoyaltyProgram()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateLoyaltyProgram$Response(params: UpdateLoyaltyProgram$Params, context?: HttpContext): Observable<StrictHttpResponse<Program>> {
    return updateLoyaltyProgram(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a loyalty program.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateLoyaltyProgram$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateLoyaltyProgram(params: UpdateLoyaltyProgram$Params, context?: HttpContext): Observable<Program> {
    return this.updateLoyaltyProgram$Response(params, context).pipe(
      map((r: StrictHttpResponse<Program>): Program => r.body)
    );
  }

  /** Path part for operation `postProgramOptin()` */
  static readonly PostProgramOptinPath = '/loyalty/programs/{programId}/optin';

  /**
   * User Program optin.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postProgramOptin()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postProgramOptin$Response(params: PostProgramOptin$Params, context?: HttpContext): Observable<StrictHttpResponse<ProgramOptin>> {
    return postProgramOptin(this.http, this.rootUrl, params, context);
  }

  /**
   * User Program optin.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postProgramOptin$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postProgramOptin(params: PostProgramOptin$Params, context?: HttpContext): Observable<ProgramOptin> {
    return this.postProgramOptin$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProgramOptin>): ProgramOptin => r.body)
    );
  }

  /** Path part for operation `getLoyaltyProgramBonuses()` */
  static readonly GetLoyaltyProgramBonusesPath = '/loyalty/programs/{programId}/bonuses';

  /**
   * Fetch loyalty program bonuses.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLoyaltyProgramBonuses()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLoyaltyProgramBonuses$Response(params: GetLoyaltyProgramBonuses$Params, context?: HttpContext): Observable<StrictHttpResponse<Bonuses>> {
    return getLoyaltyProgramBonuses(this.http, this.rootUrl, params, context);
  }

  /**
   * Fetch loyalty program bonuses.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLoyaltyProgramBonuses$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLoyaltyProgramBonuses(params: GetLoyaltyProgramBonuses$Params, context?: HttpContext): Observable<Bonuses> {
    return this.getLoyaltyProgramBonuses$Response(params, context).pipe(
      map((r: StrictHttpResponse<Bonuses>): Bonuses => r.body)
    );
  }

  /** Path part for operation `createLoyaltyProgramBonus()` */
  static readonly CreateLoyaltyProgramBonusPath = '/loyalty/programs/{programId}/bonuses';

  /**
   * Create a loyalty program bonus.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createLoyaltyProgramBonus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createLoyaltyProgramBonus$Response(params: CreateLoyaltyProgramBonus$Params, context?: HttpContext): Observable<StrictHttpResponse<Bonus>> {
    return createLoyaltyProgramBonus(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a loyalty program bonus.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createLoyaltyProgramBonus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createLoyaltyProgramBonus(params: CreateLoyaltyProgramBonus$Params, context?: HttpContext): Observable<Bonus> {
    return this.createLoyaltyProgramBonus$Response(params, context).pipe(
      map((r: StrictHttpResponse<Bonus>): Bonus => r.body)
    );
  }

  /** Path part for operation `getLoyaltyProgramBonus()` */
  static readonly GetLoyaltyProgramBonusPath = '/loyalty/programs/{programId}/bonuses/{bonusId}';

  /**
   * Fetch loyalty program bonus by id.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLoyaltyProgramBonus()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLoyaltyProgramBonus$Response(params: GetLoyaltyProgramBonus$Params, context?: HttpContext): Observable<StrictHttpResponse<Bonus>> {
    return getLoyaltyProgramBonus(this.http, this.rootUrl, params, context);
  }

  /**
   * Fetch loyalty program bonus by id.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLoyaltyProgramBonus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLoyaltyProgramBonus(params: GetLoyaltyProgramBonus$Params, context?: HttpContext): Observable<Bonus> {
    return this.getLoyaltyProgramBonus$Response(params, context).pipe(
      map((r: StrictHttpResponse<Bonus>): Bonus => r.body)
    );
  }

  /** Path part for operation `updateLoyaltyProgramBonus()` */
  static readonly UpdateLoyaltyProgramBonusPath = '/loyalty/programs/{programId}/bonuses/{bonusId}';

  /**
   * Update a loyalty program bonus.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateLoyaltyProgramBonus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateLoyaltyProgramBonus$Response(params: UpdateLoyaltyProgramBonus$Params, context?: HttpContext): Observable<StrictHttpResponse<Bonus>> {
    return updateLoyaltyProgramBonus(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a loyalty program bonus.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateLoyaltyProgramBonus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateLoyaltyProgramBonus(params: UpdateLoyaltyProgramBonus$Params, context?: HttpContext): Observable<Bonus> {
    return this.updateLoyaltyProgramBonus$Response(params, context).pipe(
      map((r: StrictHttpResponse<Bonus>): Bonus => r.body)
    );
  }

  /** Path part for operation `getLoyaltyProgramRewards()` */
  static readonly GetLoyaltyProgramRewardsPath = '/loyalty/programs/{programId}/rewards';

  /**
   * Fetch loyalty program rewards.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLoyaltyProgramRewards()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLoyaltyProgramRewards$Response(params: GetLoyaltyProgramRewards$Params, context?: HttpContext): Observable<StrictHttpResponse<Rewards>> {
    return getLoyaltyProgramRewards(this.http, this.rootUrl, params, context);
  }

  /**
   * Fetch loyalty program rewards.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLoyaltyProgramRewards$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLoyaltyProgramRewards(params: GetLoyaltyProgramRewards$Params, context?: HttpContext): Observable<Rewards> {
    return this.getLoyaltyProgramRewards$Response(params, context).pipe(
      map((r: StrictHttpResponse<Rewards>): Rewards => r.body)
    );
  }

  /** Path part for operation `createLoyaltyProgramReward()` */
  static readonly CreateLoyaltyProgramRewardPath = '/loyalty/programs/{programId}/rewards';

  /**
   * Create a loyalty program reward.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createLoyaltyProgramReward()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createLoyaltyProgramReward$Response(params: CreateLoyaltyProgramReward$Params, context?: HttpContext): Observable<StrictHttpResponse<Reward>> {
    return createLoyaltyProgramReward(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a loyalty program reward.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createLoyaltyProgramReward$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createLoyaltyProgramReward(params: CreateLoyaltyProgramReward$Params, context?: HttpContext): Observable<Reward> {
    return this.createLoyaltyProgramReward$Response(params, context).pipe(
      map((r: StrictHttpResponse<Reward>): Reward => r.body)
    );
  }

  /** Path part for operation `getLoyaltyProgramReward()` */
  static readonly GetLoyaltyProgramRewardPath = '/loyalty/programs/{programId}/rewards/{rewardId}';

  /**
   * Fetch loyalty program reward by id.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLoyaltyProgramReward()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLoyaltyProgramReward$Response(params: GetLoyaltyProgramReward$Params, context?: HttpContext): Observable<StrictHttpResponse<Reward>> {
    return getLoyaltyProgramReward(this.http, this.rootUrl, params, context);
  }

  /**
   * Fetch loyalty program reward by id.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLoyaltyProgramReward$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLoyaltyProgramReward(params: GetLoyaltyProgramReward$Params, context?: HttpContext): Observable<Reward> {
    return this.getLoyaltyProgramReward$Response(params, context).pipe(
      map((r: StrictHttpResponse<Reward>): Reward => r.body)
    );
  }

  /** Path part for operation `updateLoyaltyProgramReward()` */
  static readonly UpdateLoyaltyProgramRewardPath = '/loyalty/programs/{programId}/rewards/{rewardId}';

  /**
   * Update a loyalty program reward.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateLoyaltyProgramReward()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateLoyaltyProgramReward$Response(params: UpdateLoyaltyProgramReward$Params, context?: HttpContext): Observable<StrictHttpResponse<Reward>> {
    return updateLoyaltyProgramReward(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a loyalty program reward.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateLoyaltyProgramReward$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateLoyaltyProgramReward(params: UpdateLoyaltyProgramReward$Params, context?: HttpContext): Observable<Reward> {
    return this.updateLoyaltyProgramReward$Response(params, context).pipe(
      map((r: StrictHttpResponse<Reward>): Reward => r.body)
    );
  }

  /** Path part for operation `getLoyaltyProgramTiers()` */
  static readonly GetLoyaltyProgramTiersPath = '/loyalty/programs/{programId}/tiers';

  /**
   * Fetch loyalty program tiers.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLoyaltyProgramTiers()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLoyaltyProgramTiers$Response(params: GetLoyaltyProgramTiers$Params, context?: HttpContext): Observable<StrictHttpResponse<Tiers>> {
    return getLoyaltyProgramTiers(this.http, this.rootUrl, params, context);
  }

  /**
   * Fetch loyalty program tiers.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLoyaltyProgramTiers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLoyaltyProgramTiers(params: GetLoyaltyProgramTiers$Params, context?: HttpContext): Observable<Tiers> {
    return this.getLoyaltyProgramTiers$Response(params, context).pipe(
      map((r: StrictHttpResponse<Tiers>): Tiers => r.body)
    );
  }

  /** Path part for operation `createLoyaltyProgramTier()` */
  static readonly CreateLoyaltyProgramTierPath = '/loyalty/programs/{programId}/tiers';

  /**
   * Create a loyalty program tier.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createLoyaltyProgramTier()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createLoyaltyProgramTier$Response(params: CreateLoyaltyProgramTier$Params, context?: HttpContext): Observable<StrictHttpResponse<Tier>> {
    return createLoyaltyProgramTier(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a loyalty program tier.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createLoyaltyProgramTier$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createLoyaltyProgramTier(params: CreateLoyaltyProgramTier$Params, context?: HttpContext): Observable<Tier> {
    return this.createLoyaltyProgramTier$Response(params, context).pipe(
      map((r: StrictHttpResponse<Tier>): Tier => r.body)
    );
  }

  /** Path part for operation `getLoyaltyProgramTier()` */
  static readonly GetLoyaltyProgramTierPath = '/loyalty/programs/{programId}/tiers/{tierId}';

  /**
   * Fetch loyalty program tier by id.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLoyaltyProgramTier()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLoyaltyProgramTier$Response(params: GetLoyaltyProgramTier$Params, context?: HttpContext): Observable<StrictHttpResponse<Tier>> {
    return getLoyaltyProgramTier(this.http, this.rootUrl, params, context);
  }

  /**
   * Fetch loyalty program tier by id.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLoyaltyProgramTier$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLoyaltyProgramTier(params: GetLoyaltyProgramTier$Params, context?: HttpContext): Observable<Tier> {
    return this.getLoyaltyProgramTier$Response(params, context).pipe(
      map((r: StrictHttpResponse<Tier>): Tier => r.body)
    );
  }

  /** Path part for operation `updateLoyaltyProgramTier()` */
  static readonly UpdateLoyaltyProgramTierPath = '/loyalty/programs/{programId}/tiers/{tierId}';

  /**
   * Update a loyalty program tier.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateLoyaltyProgramTier()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateLoyaltyProgramTier$Response(params: UpdateLoyaltyProgramTier$Params, context?: HttpContext): Observable<StrictHttpResponse<Tier>> {
    return updateLoyaltyProgramTier(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a loyalty program tier.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateLoyaltyProgramTier$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateLoyaltyProgramTier(params: UpdateLoyaltyProgramTier$Params, context?: HttpContext): Observable<Tier> {
    return this.updateLoyaltyProgramTier$Response(params, context).pipe(
      map((r: StrictHttpResponse<Tier>): Tier => r.body)
    );
  }

  /** Path part for operation `getLoyaltyUser()` */
  static readonly GetLoyaltyUserPath = '/loyalty/users/{userId}';

  /**
   * Fetch Loyalty User data
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLoyaltyUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLoyaltyUser$Response(params: GetLoyaltyUser$Params, context?: HttpContext): Observable<StrictHttpResponse<LoyaltyUser>> {
    return getLoyaltyUser(this.http, this.rootUrl, params, context);
  }

  /**
   * Fetch Loyalty User data
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLoyaltyUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLoyaltyUser(params: GetLoyaltyUser$Params, context?: HttpContext): Observable<LoyaltyUser> {
    return this.getLoyaltyUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<LoyaltyUser>): LoyaltyUser => r.body)
    );
  }

  /** Path part for operation `getLoyaltyUserPoints()` */
  static readonly GetLoyaltyUserPointsPath = '/loyalty/users/{userId}/points';

  /**
   * Fetch loyalty user points.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLoyaltyUserPoints()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLoyaltyUserPoints$Response(params: GetLoyaltyUserPoints$Params, context?: HttpContext): Observable<StrictHttpResponse<UserPoints>> {
    return getLoyaltyUserPoints(this.http, this.rootUrl, params, context);
  }

  /**
   * Fetch loyalty user points.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLoyaltyUserPoints$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLoyaltyUserPoints(params: GetLoyaltyUserPoints$Params, context?: HttpContext): Observable<UserPoints> {
    return this.getLoyaltyUserPoints$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserPoints>): UserPoints => r.body)
    );
  }

  /** Path part for operation `addLoyaltyUserPoint()` */
  static readonly AddLoyaltyUserPointPath = '/loyalty/users/{userId}/points';

  /**
   * Add Loyalty User Point
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addLoyaltyUserPoint()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addLoyaltyUserPoint$Response(params: AddLoyaltyUserPoint$Params, context?: HttpContext): Observable<StrictHttpResponse<UserPoint>> {
    return addLoyaltyUserPoint(this.http, this.rootUrl, params, context);
  }

  /**
   * Add Loyalty User Point
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addLoyaltyUserPoint$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addLoyaltyUserPoint(params: AddLoyaltyUserPoint$Params, context?: HttpContext): Observable<UserPoint> {
    return this.addLoyaltyUserPoint$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserPoint>): UserPoint => r.body)
    );
  }

  /** Path part for operation `getLoyaltyUserPoint()` */
  static readonly GetLoyaltyUserPointPath = '/loyalty/users/{userId}/points/{pointId}';

  /**
   * Fetch loyalty user point.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLoyaltyUserPoint()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLoyaltyUserPoint$Response(params: GetLoyaltyUserPoint$Params, context?: HttpContext): Observable<StrictHttpResponse<UserPoint>> {
    return getLoyaltyUserPoint(this.http, this.rootUrl, params, context);
  }

  /**
   * Fetch loyalty user point.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLoyaltyUserPoint$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLoyaltyUserPoint(params: GetLoyaltyUserPoint$Params, context?: HttpContext): Observable<UserPoint> {
    return this.getLoyaltyUserPoint$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserPoint>): UserPoint => r.body)
    );
  }

  /** Path part for operation `updateLoyaltyUserPoint()` */
  static readonly UpdateLoyaltyUserPointPath = '/loyalty/users/{userId}/points/{pointId}';

  /**
   * Update Loyalty User Point
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateLoyaltyUserPoint()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateLoyaltyUserPoint$Response(params: UpdateLoyaltyUserPoint$Params, context?: HttpContext): Observable<StrictHttpResponse<UserPoint>> {
    return updateLoyaltyUserPoint(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Loyalty User Point
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateLoyaltyUserPoint$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateLoyaltyUserPoint(params: UpdateLoyaltyUserPoint$Params, context?: HttpContext): Observable<UserPoint> {
    return this.updateLoyaltyUserPoint$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserPoint>): UserPoint => r.body)
    );
  }

  /** Path part for operation `getLoyaltyUserRewards()` */
  static readonly GetLoyaltyUserRewardsPath = '/loyalty/users/{userId}/rewards';

  /**
   * Fetch loyalty user rewards.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLoyaltyUserRewards()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLoyaltyUserRewards$Response(params: GetLoyaltyUserRewards$Params, context?: HttpContext): Observable<StrictHttpResponse<UserRewards>> {
    return getLoyaltyUserRewards(this.http, this.rootUrl, params, context);
  }

  /**
   * Fetch loyalty user rewards.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLoyaltyUserRewards$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLoyaltyUserRewards(params: GetLoyaltyUserRewards$Params, context?: HttpContext): Observable<UserRewards> {
    return this.getLoyaltyUserRewards$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserRewards>): UserRewards => r.body)
    );
  }

  /** Path part for operation `addLoyaltyUserReward()` */
  static readonly AddLoyaltyUserRewardPath = '/loyalty/users/{userId}/rewards';

  /**
   * Add Loyalty User Reward
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addLoyaltyUserReward()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addLoyaltyUserReward$Response(params: AddLoyaltyUserReward$Params, context?: HttpContext): Observable<StrictHttpResponse<UserReward>> {
    return addLoyaltyUserReward(this.http, this.rootUrl, params, context);
  }

  /**
   * Add Loyalty User Reward
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addLoyaltyUserReward$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addLoyaltyUserReward(params: AddLoyaltyUserReward$Params, context?: HttpContext): Observable<UserReward> {
    return this.addLoyaltyUserReward$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserReward>): UserReward => r.body)
    );
  }

  /** Path part for operation `getLoyaltyUserReward()` */
  static readonly GetLoyaltyUserRewardPath = '/loyalty/users/{userId}/rewards/{rewardId}';

  /**
   * Fetch loyalty user reward.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLoyaltyUserReward()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLoyaltyUserReward$Response(params: GetLoyaltyUserReward$Params, context?: HttpContext): Observable<StrictHttpResponse<UserReward>> {
    return getLoyaltyUserReward(this.http, this.rootUrl, params, context);
  }

  /**
   * Fetch loyalty user reward.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLoyaltyUserReward$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLoyaltyUserReward(params: GetLoyaltyUserReward$Params, context?: HttpContext): Observable<UserReward> {
    return this.getLoyaltyUserReward$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserReward>): UserReward => r.body)
    );
  }

  /** Path part for operation `updateLoyaltyUserReward()` */
  static readonly UpdateLoyaltyUserRewardPath = '/loyalty/users/{userId}/rewards/{rewardId}';

  /**
   * Update Loyalty User Reward
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateLoyaltyUserReward()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateLoyaltyUserReward$Response(params: UpdateLoyaltyUserReward$Params, context?: HttpContext): Observable<StrictHttpResponse<UserReward>> {
    return updateLoyaltyUserReward(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Loyalty User Reward
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateLoyaltyUserReward$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateLoyaltyUserReward(params: UpdateLoyaltyUserReward$Params, context?: HttpContext): Observable<UserReward> {
    return this.updateLoyaltyUserReward$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserReward>): UserReward => r.body)
    );
  }

}
